import { Injectable } from '@angular/core';
import { DeviceDetectorService, DeviceInfo, BROWSERS } from 'ngx-device-detector';

@Injectable()
export class AppStateService {
  deviceInfo: DeviceInfo;

  constructor(private deviceDetectorService: DeviceDetectorService) {
    this.deviceInfo = this.deviceDetectorService.getDeviceInfo();
  }

  /**
   * returns true if the application is running on microsoft Edge browser and false if not (on another browser)
   */
  isBrowserEdge() {
    return this.deviceInfo.browser === BROWSERS.MS_EDGE;
  }

  isBrowserChrome() {
    return this.deviceInfo.browser === BROWSERS.CHROME;
  }

  isBrowserSafari() {
    return this.deviceInfo.browser === BROWSERS.SAFARI;
  }

  isBrowserIE() {
    return this.deviceInfo.browser === BROWSERS.IE;
  }

  isBrowserFireFox() {
    return this.deviceInfo.browser === BROWSERS.FIREFOX;
  }

  getBrowser() {
    return this.deviceInfo.browser;
  }

}
